import { graphql } from '@api/generated';
import { getClient } from '../../../api/client';

const updateWorkflowNameSettingMutation = graphql(`
  mutation updateWorkflowNameSettingMutation(
    $contactCenterSettings: ContactCenterSettingsInput!
  ) {
    updateContactCenterSettings(contactCenterSettings: $contactCenterSettings) {
      showWorkflowNameOnInboundCalls {
        isEnabled
      }
    }
  }
`);

async function updateWorkflowNameSetting(isEnabled: boolean): Promise<boolean> {
  const result = await getClient().mutate({
    mutation: updateWorkflowNameSettingMutation,
    variables: {
      contactCenterSettings: {
        showWorkflowNameOnInboundCalls: {
          isEnabled,
        },
      },
    },
  });

  if (result.errors?.length) {
    throw new Error(result.errors[0].message);
  }

  return (
    result.data?.updateContactCenterSettings?.showWorkflowNameOnInboundCalls
      ?.isEnabled ?? isEnabled
  );
}

export default updateWorkflowNameSetting;
